// import { create, all } from "mathjs";
import EventEmitter from "./EventEmitter";

export const EventBus = new EventEmitter();

const config = {
    number: "BigNumber",
    precision: 20
};

// const math = create(all, config);

// //乘
// export const numberRide = (arg1, arg2) => {
//     return math.number(
//         math.multiply(math.bignumber(arg1), math.bignumber(arg2))
//     );
// };

// //除
// export const numberExcept = (arg1, arg2) => {
//     return math.number(math.divide(math.bignumber(arg1), math.bignumber(arg2)));
// };

// //加
// export const numberAdd = (arg1, arg2) => {
//     return math.number(math.add(math.bignumber(arg1), math.bignumber(arg2)));
// };

// //减
// export const numberSub = (arg1, arg2) => {
//     return math.number(
//         math.subtract(math.bignumber(arg1), math.bignumber(arg2))
//     );
// };

// 确保车辆树数据已加载完成
export const readyGo = () => {
    return new Promise(resolve => {
        if (StarSoft.CarTreeFinish) {
            return resolve(true);
        }
        const finshFn = () => {
            resolve(true);
        };
        EventBus.on("CarTreeFinish", finshFn);
    });
};

// 时分秒转换为秒 "12:30:30" ==> 45030
export const timeToStamp = date => {
    const [hour, minute, second] = date.split("-");
    return hour * 3600 + minute * 60 + second;
};

// 获取唯一id
export const nanoid = (t = 21) => {
    let e = "";
    const r = crypto.getRandomValues(new Uint8Array(t));
    for (; t--;) {
        // eslint-disable-next-line no-bitwise
        const n = 63 & r[t];
        if (n < 36) {
            e += n.toString(36);
        } else if (n < 62) {
            e += (n - 26).toString(36).toUpperCase();
        } else if (n < 63) {
            e += "_";
        } else {
            e += "-";
        }
    }
    return e;
};
// blobToArrayBuffer
const blobToArrayBuffer = (blob) =>
    new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        const arrayBuffer = fileReader.result;
        resolve(arrayBuffer);
      };
      fileReader.onerror = reject;
      fileReader.readAsArrayBuffer(blob);
    });
  
  // blobToUint8Array
  export const blobToUint8Array = (blob) =>
    blobToArrayBuffer(blob).then((buff) => new Uint8Array(buff));

// 当前页下载文件
export const downLoadFile = (fileURL) => {
    console.log("fileURL:", fileURL);
    if (!fileURL) return $message("文件丢失", "error");
    if (!fileURL.startsWith("http")) {
        fileURL = StarSoft.SysInfo.downloadUrl + fileURL;
    }
    let a = document.createElement("a");
    a.href = fileURL;
    if (window.self !== window.top) {
        a.target = "_blank";
    }
    a.click();
    a = null;
};

// oss视频下载
export const downLoadVideo = (url) => {
    // const a = document.createElement("a");
    // a.href = `${url}?response-content-type=video/mpeg4`;
    // a.href = url + "?response-content-type=application/octet-stream";
    // a.download = "xxx";
    // a.click();
    downLoadFile(`${url}?response-content-type=application/octet-stream`);

    // const a = document.createElement("a");
    // a.style.display = "none";
    // a.href = `${url}?response-content-type=application/octet-stream`;
    // // 使用target="_blank"时，添加rel="noopener noreferrer" 堵住钓鱼安全漏洞 防止新页面window指向之前的页面
    // a.rel = "noopener noreferrer";
    // document.body.append(a);
    // a.click();
    // setTimeout(() => {
    //   a.remove();
    // }, 1000);
};
// 判断对象是否为空
export const isEmptyObject = (val) => Object.keys(val).length === 0;

/**
 * 视频截屏函数
 * @date 2024/4/11 - 09:17:13
 * @author zenghao <1966252061@qq.com>
 *
 * @export
 * @param {*} dom video的dom对象
 * @param {{ type: string; }} [config={ type: "download" }]
 * @returns {*}
 */
export function screenShot(dom, config = { type: "download" }) {
    const canvas = document.createElement("canvas");
    if (config.originalSize) {
        canvas.width = dom.videoWidth;
        canvas.height = dom.videoHeight;
    } else {
        canvas.width = dom.offsetWidth;
        canvas.height = dom.offsetHeight;
    }
    canvas.getContext("2d").drawImage(dom, 0, 0, canvas.width, canvas.height);
    if (config.type == "download") {
        let a = document.createElement("a");
        a.href = canvas.toDataURL("image/png");
        a.download = config.picName || Date.now();
        a.click();
        a = null;
        return;
    }
    if (config.type == "img") {
        return canvas.toDataURL("image/png");
    }
}

export const transVideo = async (blobs, fileName, duration = 0) => {
    const noticeId = nanoid(15);
    let worker = null;
    try {
        const dataList = await blobToUint8Array(blobs);
        EventBus.trigger("TransVideo", noticeId);
        const timeFilter = /time=(.*?) /;
        worker = new Worker("./static/lib/WebmToMp4/ffmpeg-worker-mp4.js");
        worker.onmessage = (e) => {
            const msg = e.data;
            switch (msg.type) {
                case "ready":
                    worker.postMessage({
                        type: "run",
                        arguments: [
                            "-i",
                            "input.webm",
                            "-an",
                            "-r",
                            "25",
                            "-c:v",
                            "libx264",
                            "-preset",
                            "ultrafast",
                            "output.mp4",
                        ],
                        MEMFS: [{ name: "input.webm", data: dataList }],
                    });
                    break;
                case "error":
                    console.warn("error", msg.data);
                    $message("视频格式转化失败", "error");
                    worker.terminate();
                    EventBus.trigger("TransVideo", noticeId, null, true);
                    break;
                case "abort":
                    console.warn("abort", msg.data);
                    $message("视频格式转化失败", "error");
                    worker.terminate();
                    EventBus.trigger("TransVideo", noticeId, null, true);
                    break;
                case "stderr":
                    if (timeFilter.exec(msg.data)) {
                        const time = timeToSeconds(timeFilter.exec(msg.data)[1]);
                        let perStr = ((time / duration) * 100).toFixed(2);
                        if (perStr > 100) perStr = 100;
                        perStr += "%";
                        EventBus.trigger("TransVideo", noticeId, perStr);
                    }
                    break;
                case "done":
                    {
                        worker.terminate();
                        EventBus.trigger("TransVideo", noticeId, null, true);
                        const out = msg.data.MEMFS[0];
                        const a = document.createElement("a");
                        a.href = URL.createObjectURL(
                            new Blob([out.data], { type: "video/mp4" })
                        );
                        a.download = `${fileName}-${new Date().format("yyyyMMddHHmmss")}`;
                        a.click();
                        URL.revokeObjectURL(a.href);
                        a.remove();
                    }
                    break;
                default:
                    break;
            }
        };
    } catch (error) {
        console.error(error);
        $message("视频格式转化失败", "error");
        worker && worker.terminate();
        EventBus.trigger("TransVideo", noticeId, null, true);
    }
};


// 封装工具函数（可放在 utils.js 中全局复用）
export function safeJsonParse(str, defaultValue = {},errInfo = '') {
  // 先判断空值（空字符串、null、undefined）
  if (!str || typeof str !== 'string') {
    return defaultValue;
  }
  try {
    // 尝试解析，解析失败返回默认值
    return JSON.parse(str);
  } catch (e) {
    console.warn(errInfo, ' JSON 解析失败 - 采用默认值,原始值:', str,'，错误信息：', e);
    return defaultValue;
  }
}